module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.ttf?bb49393b04bbf312a6cd055a051121d3";